import { logError } from '../../logError'

export const getCurrentLocale = (): string => {
    try {
        if (typeof window !== 'undefined') {
            // Option 1: Get locale from URL pathname (next-intl approach)
            const pathname = window.location.pathname
            const localeFromPath = pathname.split('/')[1]

            // Check if it's a valid locale (ar or en)
            if (['ar', 'en'].includes(localeFromPath)) {
                return localeFromPath
            }

            // Option 2: Get from localStorage where next-intl might store it
            const storedLocale = localStorage.getItem('NEXT_LOCALE') || localStorage.getItem('locale')
            if (storedLocale && ['ar', 'en'].includes(storedLocale)) {
                return storedLocale
            }

            // Option 3: Get from HTML lang attribute (set by next-intl)
            const htmlLang = document.documentElement.lang
            if (htmlLang && ['ar', 'en'].includes(htmlLang)) {
                return htmlLang
            }

            // Option 4: Check browser language for Arabic
            const browserLang = navigator.language.toLowerCase()
            if (browserLang.includes('ar') || browserLang.includes('arabic')) {
                return 'ar'
            }
        }
        return 'en'
    } catch (error) {
        logError('getCurrentLocale', error)
        return 'en'
    }
}
